import _defineProperty from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["blok"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import e, { forwardRef as m } from "react";
import { getComponent as a, getEnableFallbackComponent as p, getCustomFallbackComponent as c } from "./index2.mjs";
var u = m(function (_ref, l) {
  var t = _ref.blok,
      o = _objectWithoutProperties(_ref, _excluded);

  if (!t) return console.error("Please provide a 'blok' property to the StoryblokComponent"), /* @__PURE__ */e.createElement("div", null, "Please provide a blok property to the StoryblokComponent");
  var n = a(t.component);
  if (n) return /* @__PURE__ */e.createElement(n, _objectSpread({
    ref: l,
    blok: t
  }, o));

  if (p()) {
    var r = c();
    return r ? /* @__PURE__ */e.createElement(r, _objectSpread({
      blok: t
    }, o)) : /* @__PURE__ */e.createElement(e.Fragment, null, /* @__PURE__ */e.createElement("p", null, "Component could not be found for blok", " ", /* @__PURE__ */e.createElement("strong", null, t.component), "! Is it configured correctly?"));
  }

  return /* @__PURE__ */e.createElement("div", null);
});
u.displayName = "StoryblokComponent";
export { u as default };